/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OtherSystemType } from './OtherSystemType';
import {
    OtherSystemTypeFromJSON,
    OtherSystemTypeFromJSONTyped,
    OtherSystemTypeToJSON,
    OtherSystemTypeToJSONTyped,
} from './OtherSystemType';
import type { OtherSystemCategory } from './OtherSystemCategory';
import {
    OtherSystemCategoryFromJSON,
    OtherSystemCategoryFromJSONTyped,
    OtherSystemCategoryToJSON,
    OtherSystemCategoryToJSONTyped,
} from './OtherSystemCategory';

/**
 * 
 * @export
 * @interface OtherSystemSource
 */
export interface OtherSystemSource {
    /**
     * 
     * @type {string}
     * @memberof OtherSystemSource
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherSystemSource
     */
    domainId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherSystemSource
     */
    centreId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherSystemSource
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherSystemSource
     */
    name?: string;
    /**
     * 
     * @type {OtherSystemType}
     * @memberof OtherSystemSource
     */
    type?: OtherSystemType;
    /**
     * 
     * @type {OtherSystemCategory}
     * @memberof OtherSystemSource
     */
    category?: OtherSystemCategory | null;
}



/**
 * Check if a given object implements the OtherSystemSource interface.
 */
export function instanceOfOtherSystemSource(value: object): value is OtherSystemSource {
    return true;
}

export function OtherSystemSourceFromJSON(json: any): OtherSystemSource {
    return OtherSystemSourceFromJSONTyped(json, false);
}

export function OtherSystemSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherSystemSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'domainId': json['domainId'] == null ? undefined : json['domainId'],
        'centreId': json['centreId'] == null ? undefined : json['centreId'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : OtherSystemTypeFromJSON(json['type']),
        'category': json['category'] == null ? undefined : OtherSystemCategoryFromJSON(json['category']),
    };
}

export function OtherSystemSourceToJSON(json: any): OtherSystemSource {
    return OtherSystemSourceToJSONTyped(json, false);
}

export function OtherSystemSourceToJSONTyped(value?: OtherSystemSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'domainId': value['domainId'],
        'centreId': value['centreId'],
        'remoteId': value['remoteId'],
        'name': value['name'],
        'type': OtherSystemTypeToJSON(value['type']),
        'category': OtherSystemCategoryToJSON(value['category']),
    };
}

